import { configureStore } from "@reduxjs/toolkit";
import { authReducer } from "./slice/authSlice";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
import { persistReducer, persistStore } from "redux-persist";
import { combineReducers } from "redux";
import { encryptTransform } from "redux-persist-transform-encrypt";
import expireReducer from "redux-persist-transform-expire";
import locationReducer from "./slice/location/locationSlice";
import { attendanceReducer } from "./slice/attendance/attendanceSlice";
import { initialState } from "./slice/authSlice";
import { userPermissionsReducer } from "./slice/userPermissionSlice";
import { notificationReducer } from "./slice/notification";

const encryptor = encryptTransform({
  secretKey: "ECB7D31A161735CD27C78PPEED7E82A",
  onError: function (error) {
    console.error("Encryption error:", error);
  },
});

// Create the expiry reducer
const expireConfig = {
  expireSeconds: 3600,
  expiredState: initialState,
  autoExpire: true,
};

const persistConfig = {
  key: "root",
  version: 1,
  storage,
  transforms: [encryptor, expireReducer(expireConfig)],
};

const rootReducer = combineReducers({
  auth: authReducer,
  // location: locationReducer,
  attendance: attendanceReducer,
  userPermissions: userPermissionsReducer,
  notifications: notificationReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

// const store = configureStore({
//   reducer: persistedReducer,
// });

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Disable serializable checks
    }),
});

export const persistor = persistStore(store);
export default store;
